export default {
  prompt: 'Tips',
  yes: 'OK',
  no: 'Cancellation',
  cancel: 'Cancel sending',
  navIndex: {
    joinTeam: 'Join Team',
    createTeam: 'Create Team',
    teamHome: 'Team Home',
    memberManagement: 'Member Management',
    projectManagement: 'Project Management',
    report: 'Report',
    proOverview: 'Project Overview',
    userOverview: 'User Overview',
    teamBalance: 'Team Income'
  },
  joinTeam: 'Join Team',
  teamName: 'team name',
  search: 'search',
  creator: 'creator',
  mainBusiness: 'main business',
  level: 'level',
  reputation: 'reputation',
  operation: 'operation',
  application: 'Application',
  label: {
    picture: 'picture',
    text: 'text',
    video: 'video',
    voice: 'voice',
    collect: 'collect'
  },
  join: {
    comfirmTitle: 'Ongoing application operation, whether to continue'
  },
  applyJoin: {
    wait: 'Request has been sent, please wait team deal'
  },
  teamInfo: 'Team Information',
  leaveTeam: 'Leave Team',
  disbandTeam: 'Disband Team',
  teamNews: 'Team News',
  noNews: 'No News',
  showTeamInfo: {
    founder: 'Founder',
    createTime: 'Create Time',
    id: 'Team ID',
    reputation: 'Reputation',
    level: 'Level',
    interestRate: 'Interest Rate',
    mainBusiness: 'Main Business',
    phone: 'Phone',
    email: 'Email',
    introduction: 'Introduction',
    edit: 'edit',
    submit: 'Submit'
  },
  teamNew: {
    index5: 'Leave the union',
    index6: 'Union removed',
    index7: 'Join a union',
    index8: 'Mission application passed',
    index9: 'Task completed',
    index10: 'unknown'
  },
  userManage: {
    manage0: 'Loading desperately',
    manage1: 'Member rights management',
    manage2: 'Multiple add',
    manage3: 'Member name',
    manage4: 'Authority',
    manage5: 'operation',
    manage6: 'edit',
    manage7: 'delete',
    manage8: 'Multiple add permissions',
    manage9: 'project id',
    manage10: 'Union id',
    manage11: 'username',
    manage12: 'please choose',
    manage13: 'Transcription authority',
    manage14: 'Quality inspection authority',
    manage15: 'Modify permissions',
    manage21: 'Authority cannot be empty',
    manage22: 'Member cannot be empty',
    manage23: 'Multiple adding permissions',
    manage24: 'Whether to continue',
    manage26: 'Successfully modified',
    manage27: 'This action will delete the task',
    manage28: 'Middle user :',
    manage29: 'permission,Whether to continue?',
    manage31: 'Tips',
    manage32: 'determine',
    manage33: 'Cancellation',
    manage34: 'successfully deleted'
  },
  projManage: {
    projManage: 'Project Management',
    teamProj: 'Team Project',
    projList: 'Project List',
    projType: 'Project Type',
    num: 'number',
    name: 'name',
    type: 'type',
    startTime: 'start time',
    operation: 'operation',
    application: 'application',
    label: {
      voicetag: 'voice tag',
      picturetag: 'picture tag',
      texttag: 'text tag',
      videotag: 'video tag',
      mixcoll: 'mixed task collection',
      textcoll: 'text collection',
      picturecoll: 'picture collection',
      voicecoll: 'voice collection',
      videocoll: 'video collection'
    },
    applygo: 'Ongoing application operation, whether to continue',
    applywait: 'Application has been sent, please wait for processing'
  },
  projTeam: {
    processing: 'Processing',
    applying: 'Applying',
    applyfail: 'Application failed',
    taskname: 'task name',
    tasktype: 'task type',
    starttime: 'start time',
    operation: 'operation',
    userRights: 'Member rights management'
  },
  report: {
    projId: 'project ID',
    search: 'search',
    dataCollTime: 'Data Collection Time',
    taskNum: 'Tasks',
    taskRemain: 'Remaining tasks',
    finishNum: 'Completed Tasks',
    progress: 'Project progress',
    checkProgress: 'Quality inspection progress',
    completion: 'Completion situation',
    check: 'Quality inspection situation',
    qualified: 'Qualified status',
    nodata: 'No data temporarily',
    teamTask: 'Team Tasks',
    remainTask: 'Remaining tasks',
    recoverTask: 'Recovery tasks',
    otherTask: 'Other team tasks',
    qualifiedTask: 'Qualified tasks',
    unreviewedTask: 'Unreviewed tasks',
    unqualified: 'Unqualified tasks',
    qualified0: 'Qualified',
    qualified1: 'Qualified once',
    qualified2: 'Qualified twice',
    qualified3: 'Multiple qualified',
    setProId: 'Please select the project ID',
    getdata: 'Data acquisition, please try later',
    userStatistics: 'User Statistics',
    userDetails: 'User Details',
    enterUsername: 'Enter username',
    exportData: 'Export data',
    username: 'Username',
    total: 'Completed',
    qualifiedNo: 'Unqualified',
    notreviewed: 'Unreviewed',
    qualifiedrate: 'qualified rate',
    unqualifiedrate: 'unqualified rate',
    totalNum: 'completion number',
    qualifiedNum: 'qualified number',
    unqualifiedNum: 'unqualified number',
    taskTitle: 'TOP10-Complete'
  },
  loading: 'loading...',
  balance: {
    balance: 'Team balance(Fanhanbi)',
    totalRevenue: 'Total revenue(Fanhanbi)',
    totalExpenses: 'Total expenses(Fanhanbi)',
    bill: 'Team bill',
    date: 'date',
    remarks: 'remarks',
    revenue: 'revenue',
    expenses: 'expenses',
    fanhanbi: 'Fanhanbi'
  },
  create: {
    create: 'Create Team',
    noCompany: 'The name of the team must not contain the company name',
    noAuthority: 'No authority yet',
    certificate: 'Team can only be created through enterprise certification',
    goCertificate: 'Go to certification',
    teamName: 'Team Name',
    mainBusiness: 'Main Business',
    email: 'Email',
    createNow: 'Create now',
    label: {
      picture: 'picture',
      text: 'text',
      video: 'video',
      voice: 'voice',
      collect: 'collect'
    },
    teamExist: 'Team name exists',
    rules: {
      rlue1: 'Please enter the name of the union',
      rlue2: 'Please enter at least one major task',
      rlue3: 'Please enter your contact email ',
      rlue4: 'Union being created whether to continue',
      rlue5: 'Trade union creation success',
      rlue6: 'Are disengaging from the union continues',
      rlue7: 'Successful disengagement from the union'
    }
  },
  // 2022-4-2开始迭代 暂无英文++@lu
  // 侧边栏++@lu
  // 创建公会这里++@lu
  newnav: {
    joinTeam: '加入泛团',
    createTeam: '创建泛团',
    changeTeam: '修改泛团',
    homePage: '泛团首页',
    projectManagement: '项目管理',
    announcement: '泛团公告',
    onlineAnnouncement: '线上公告',
    memberManagement: '成员管理',
    statement: '报表',
    earnings: '泛团收益',
    setting: '泛团设置',
    announce: '发布公告',
    historyAnnouncement: '历史公告',
    fhAnnouncement: '泛函公告'
  },
  newcreate: {
    enterprise: {
      title: '创建企业性质泛团',
      line1: '仅完成企业认证的用户才可以',
      line2: '企业泛团创建者拥有发布者权限，可以使用泛函平台发布并完成您自己的项目'
    },
    person: {
      title: '创建个人性质泛团',
      line1: '个人实名认证用户仅可创建个人性质泛团',
      line2: '个人性质泛团不拥有同发布者权限，如需发布者权限请联系我们'
    },
    next: '下一步',
    // --------------
    // create
    createTeam: {
      name: '泛团名称：',
      placeholder: '不可包含个人联系方式等信息',
      mainBusiness: '主要业务：',
      picture: '图片',
      text: '文本',
      video: '视频',
      voice: '声音',
      collect: '采集',
      threeD: '3D点云标注',
      tel: '联系电话：',
      email: '联系邮箱：',
      introduce: '泛团简介：',
      yesNo1: '泛团是否开放申请：',
      yesNo2: '加入泛团是否需要审核：',
      back: '返回',
      submit: '提交',
      yes: '是',
      no: '否',
      nameError1: '泛团名称不能超过30个字符',
      nameError2: '泛团名称含有数字',
      nameError3: '泛团名已存在',
      phoneError: '请输入正确的手机号码',
      emailError: '请输入正确的邮箱格式',
      // 一些泛团设置的
      setting: '泛团设置',
      sure: '确定'
    },
    createdTeam: {
      ftName: '泛团名',
      mainBusiness: '主要业务',
      reviewProgress: '审核进度',
      remark: '备注',
      toAudit: '待审核',
      activate: '激活',
      amend: '修改',
      abarbeitung: '整改',
      fail: '激活失败'
    }
  },
  // users-list
  usersList: {
    memberManagement: 'Member Management',
    usersList: 'Member list',
    applyList: 'Application list',
    absorb: '吸纳会员',
    gender: '性别：',
    birthday: '年龄：',
    country: '地区：',
    man: '男',
    women: '女',
    speciality: '擅长任务：',
    username: 'username',
    teamId: 'team ID',
    roles: 'role',
    plsChoose: 'Please choose',
    normal: 'ordinary member',
    manage: 'administrator',
    founder: 'founder',
    operation: 'operation',
    issue: 'Issue Fanhanbi',
    delete: 'delete',
    pass: 'pass',
    refuse: 'refuse',
    remain: 'Remaining Fanhanbi: ',
    number: 'Fanhanbi',
    no: 'Cancellation',
    yes: 'OK',
    inputNum: 'Please enter the number of Fanhanbi',
    inputTips: 'Not enough Fanhanbi',
    roleMust: 'Role cannot be empty',
    roleSucc: 'Role modified successfully',
    roleerr: 'Role modification failed',
    delgo: 'Delete operation in progress, whether to continue',
    delsucc: 'success',
    delerr: 'Failure',
    confirm: 'Please confirm ',
    opesucc: 'success',
    fanhansucc: 'success',
    err: 'Failure'
  },
  teamIndex: {
    title: '泛团名称',
    recruitMembers: '吸纳成员',
    leave: '退出泛团',
    id: '泛团ID',
    createdTime: '创建时间',
    originator: '创始人',
    teamType: '泛团类型',
    finishedCount: '完成项目数',
    businessTeam: '企业泛团',
    personTeam: '个人泛团',
    projectType: '项目类型',
    phone: '联系电话',
    email: '联系邮箱',
    introduction: '泛团简介',
    tuan: '泛团公告',
    han: '泛函公告',
    read: '查看'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/team.js